/**
 * 账单图片渲染工具
 */
import html2canvas from 'html2canvas';
import JSZip from 'jszip';

const DEFAULT_OPTIONS = {
  scale: 2,
  useCORS: true,
  backgroundColor: '#ffffff'
};

/**
 * 渲染 DOM 元素为图片 data URL
 */
export async function renderToImage(element, options = {}) {
  const canvas = await html2canvas(element, { ...DEFAULT_OPTIONS, ...options });
  return canvas.toDataURL('image/png');
}

/**
 * data URL 转 Blob
 */
export function dataUrlToBlob(dataUrl) {
  const parts = dataUrl.split(',');
  const mime = parts[0].match(/:(.*?);/)[1];
  const bstr = atob(parts[1]);
  const n = bstr.length;
  const u8arr = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    u8arr[i] = bstr.charCodeAt(i);
  }
  return new Blob([u8arr], { type: mime });
}

/**
 * 触发下载 Blob 为文件
 */
export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * 打包多个元素为 ZIP 下载
 * @param {Array} items - [{ element: HTMLElement, fileName: string }]
 */
export async function downloadAsZip(items) {
  const zip = new JSZip();

  for (const item of items) {
    const dataUrl = await renderToImage(item.element);
    const blob = dataUrlToBlob(dataUrl);
    zip.file(item.fileName, blob);
  }

  const zipBlob = await zip.generateAsync({ type: 'blob' });
  const timestamp = new Date().toLocaleString().replace(/[/:\s]/g, '-');
  downloadBlob(zipBlob, `费用分摊账单_${timestamp}.zip`);
}

/**
 * 复制图片到剪贴板
 */
export async function copyImageToClipboard(dataUrl) {
  const blob = dataUrlToBlob(dataUrl);
  await navigator.clipboard.write([
    new ClipboardItem({ [blob.type]: blob })
  ]);
}
